.dd{user-select:none;}